import { render, staticRenderFns } from "./SignUpCard.htm?vue&type=template&id=b80b1a1a&scoped=true&"
import script from "./SignUpCard.ts?vue&type=script&lang=js&"
export * from "./SignUpCard.ts?vue&type=script&lang=js&"
import style0 from "./SignUpCard.scss?vue&type=style&index=0&id=b80b1a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80b1a1a",
  null
  
)

export default component.exports